<app-header></app-header>

<div class="flex">
  <app-sidebar optionMenu="7"></app-sidebar>

  <div class="flex cursor-pointer h-full relative left-16 top-8" [routerLink]="['/ia']">
    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none">
      <path d="M8 15L1 8L8 1" stroke="#3C00A3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
    <p class="relative left-2 bottom-1">ATRÁS</p>
  </div>

  <div class="bg-white p-6 rounded-2xl relative h-full w-[70%] top-20">
    <h2 class="text-2xl font-bold mb-8">Texto a voz</h2>

    <div class="p-14" [formGroup]="form">

      <p class="text-dark-light font-bold mb-2">
        Empieza a escribir o pegar texto
      </p>

      <textarea formControlName="text" class="w-full h-44 bg-[#eef2f1] rounded-md p-4 text-sm outline-none resize-none"
        placeholder="Puedes escribir texto directamente aquí o pegarlo desde tu herramienta favorita">
          </textarea>

      <div class="mb-8 w-[30%] mt-6">
        <label class="block text-sm font-bold mb-2">Voz</label>

        <select formControlName="voiceId" class="w-full bg-[#eef2f1] border border-[#3C00A3] rounded-md px-4 py-3">
          <option value="" disabled>Selecciona una voz</option>
          <option *ngFor="let voz of voces" [value]="voz.voice_id">
            {{ voz.name }}
          </option>
        </select>
      </div>

      <button *ngIf="!hasAudio" (click)="generarVersion()" [disabled]="form.invalid || loading"
        class="bg-[#3C00A3] text-white px-6 py-3 rounded-xl mt-6 flex gap-1 w-[22%]">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M12 5V19M5 12H19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        Generar audio
      </button>

      <div *ngIf="hasAudio" class="mt-10 flex flex-col gap-6">

        <audio #audioRef *ngIf="audioUrl" [src]="audioUrl" (loadedmetadata)="onAudioLoaded()"
          (timeupdate)="onTimeUpdate()" hidden>
        </audio>

        <div class="flex flex-col gap-4 w-[55%]">
          <div class="flex items-center justify-center gap-6">

            <button (click)="skip(-10)" class="text-[#3C00A3] font-bold">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M23.5688 8.83113C22.7192 5.74242 20.7083 3.16349 17.9081 1.57915C15.1079 -0.00518702 11.8553 -0.415016 8.74347 0.429632C6.92362 0.924426 5.29479 1.80406 3.89722 3.04354C2.67058 4.13309 1.67016 5.48253 0.976404 6.96691L-0.00390625 6.55708L0.363082 9.44088L2.69069 7.68661L1.72546 7.28178C2.36895 5.90735 3.30401 4.65287 4.43514 3.64829C5.73719 2.49377 7.25541 1.67411 8.94959 1.20931C11.8503 0.419636 14.8817 0.799478 17.4959 2.27886C20.105 3.75824 21.9802 6.16224 22.7745 9.04104C23.5688 11.9198 23.1867 14.9386 21.6986 17.5375C20.2106 20.1364 17.7925 21.9956 14.8968 22.7853C12.0011 23.575 8.96467 23.1951 6.35051 21.7158C3.74138 20.2364 1.86622 17.8324 1.07192 14.9536C1.01159 14.7387 0.790396 14.6087 0.574225 14.6687C0.358054 14.7287 0.227346 14.9486 0.287673 15.1635C1.13728 18.2522 3.14817 20.8311 5.94833 22.4155C8.7485 23.9998 12.0011 24.4096 15.1079 23.565C18.2148 22.7203 20.8088 20.7212 22.4025 17.9373C23.9961 15.1535 24.4083 11.9198 23.5587 8.83113H23.5688Z"
                  fill="#3C00A3" />
              </svg>
            </button>

            <button (click)="togglePlay()"
              class="w-14 h-14 rounded-full bg-[#3C00A3] flex items-center justify-center text-white text-xl">
              {{ isPlaying ? '❚❚' : '▶' }}
            </button>

            <button (click)="skip(10)" class="text-[#3C00A3] font-bold">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M0.42341 8.83113C1.27301 5.74242 3.28391 3.16349 6.08407 1.57915C8.88424 -0.00518702 12.1369 -0.415016 15.2487 0.429632C17.0686 0.924426 18.6974 1.80406 20.095 3.04354C21.3216 4.13309 22.322 5.48253 23.0158 6.96691L23.9961 6.55708L23.6291 9.44088L21.3015 7.68661L22.2667 7.28178C21.6232 5.90735 20.6882 4.65287 19.557 3.64829C18.255 2.49377 16.7368 1.67411 15.0426 1.20931C12.1419 0.419636 9.11047 0.799478 6.49631 2.27886C3.88717 3.75824 2.01202 6.16224 1.21771 9.04104C0.423412 11.9198 0.805481 14.9386 2.29354 17.5375C3.7816 20.1364 6.1997 21.9956 9.09538 22.7853C11.9911 23.575 15.0275 23.1951 17.6417 21.7158C20.2508 20.2364 22.126 17.8324 22.9203 14.9536C22.9806 14.7387 23.2018 14.6087 23.418 14.6687C23.6341 14.7287 23.7648 14.9486 23.7045 15.1635C22.8549 18.2522 20.844 20.8311 18.0439 22.4155C15.2437 23.9998 11.9911 24.4096 8.88424 23.565C5.77741 22.7203 3.18336 20.7212 1.58973 17.9373C-0.00390434 15.1535 -0.416136 11.9198 0.433466 8.83113H0.42341Z"
                  fill="#3C00A3" />
              </svg>
            </button>

          </div>
          <div class="flex items-center gap-3 text-sm text-[#3C00A3]">

            <span>{{ formatTime(currentTime) }}</span>

            <input type="range" min="0" [max]="duration" [value]="currentTime" (input)="seek($event)"
              class="w-full accent-[#3C00A3]" />

            <span>{{ formatTime(duration) }}</span>

          </div>

        </div>

        <div class="flex gap-6 gap-x-[90px]">
          <button (click)="regenerarAudio()"
            class="flex items-center gap-2 bg-[#3C00A3] text-white px-6 py-3 rounded-xl">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 2.25C17.385 2.25 21.75 6.615 21.75 12C21.75 17.385 17.385 21.75 12 21.75C10.7194 21.7516 9.45111 21.5001 8.26801 21.0099C7.08491 20.5198 6.01033 19.8007 5.106 18.894C4.97352 18.7518 4.9014 18.5638 4.90483 18.3695C4.90825 18.1752 4.98697 17.9898 5.12438 17.8524C5.26179 17.715 5.44718 17.6363 5.64148 17.6328C5.83578 17.6294 6.02382 17.7015 6.166 17.834C7.12537 18.7932 8.3065 19.5011 9.60476 19.8949C10.903 20.2886 12.2784 20.3561 13.609 20.0914C14.9396 19.8267 16.1843 19.238 17.233 18.3773C18.2818 17.5166 19.102 16.4106 19.6212 15.1572C20.1404 13.9038 20.3425 12.5418 20.2096 11.1916C20.0766 9.84148 19.6128 8.54496 18.8591 7.4169C18.1055 6.28883 17.0852 5.36404 15.8888 4.72442C14.6924 4.08481 13.3567 3.75012 12 3.75C9.444 3.75 7.578 4.918 5.833 6.583L7.75 8.5C7.75 8.69891 7.67098 8.88968 7.53033 9.03033C7.38968 9.17098 7.19891 9.25 7 9.25H3C2.80109 9.25 2.61032 9.17098 2.46967 9.03033C2.32902 8.88968 2.25 8.69891 2.25 8.5V4.5C2.25 4.30109 2.32902 4.11032 2.46967 3.96967C2.61032 3.82902 2.80109 3.75 3 3.75L4.77 5.52C6.67 3.705 8.905 2.25 12 2.25Z"
                fill="white" />
            </svg>
            Regenerar audio
          </button>

          <button (click)="downloadAudio()"
            class="flex items-center gap-2 bg-[#3C00A3] text-white px-6 py-3 rounded-xl">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 15V3M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
                stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M7 10L12 15L17 10" stroke="white" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            Descargar audio
          </button>
        </div>
      </div>
    </div>
  </div>

</div>